import API from "../../../../../services/api";

export const SOLICITUDES_PROVEEDOR_API = {
    new: async (solicitud) => {
        return API.post('/solicitudes-proveedor', solicitud).then(res => res.data);
    }
}